import { create } from 'zustand';

const useStore = create(() => ({
  nextUrl: null,
  prevUrl: null,
  totalPages: null,
  startPage: 1,
}));

export { useStore as usePaginationStore };
